import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class EncontroTecnicoService {
    private urlModulo = `${environment.urlAPI}/encontro-tecnico`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista dos possíveis convidados do Encontro Técnico
     */
    public getListaEncontroTecnico(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-listaconvidados`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.convidados);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera o evento pelo código do evento
     */
    public getListaEvento(codEvento: number): Promise<any> {
        const params = new HttpParams().set('codEvento', codEvento.toString());

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-eventobyid`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.convidados);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista de convidados do evento já cadastrado para determinada data
     */
    public getDataEvento(dataEvento: string): Promise<any> {
        const params = new HttpParams().set('dataEvento', dataEvento);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-dataevento`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.convidados);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Salva todos os convidados do evento
     */
    public gravaEvento(eventoData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarevento`, eventoData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Finaliza o evento e registra a presença dos convidados
     */
    public finalizarEvento(eventoData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-finalizarevento`, eventoData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza a presença do convidado no evento
     */
    public presencaEvento(codigo: number, presenca: boolean): Promise<any> {
        const presencaData = {
            codigo: codigo,
            presenca: presenca
        };

        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-presenca`, presencaData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/encontro-tecnico.service.ts